// extracted by mini-css-extract-plugin
export var dark = "LoginForm-module--dark--31e69";
export var darkSeparator = "LoginForm-module--darkSeparator--cfce9";
export var form = "LoginForm-module--form--b9c9f";
export var formName = "LoginForm-module--formName--2d753";
export var helpButton = "LoginForm-module--helpButton--7fa8a";
export var helpLinks = "LoginForm-module--helpLinks--48931";
export var loginform = "LoginForm-module--loginform--16665";
export var offlineMsg = "LoginForm-module--offlineMsg--6df24";
export var selectorWrapper = "LoginForm-module--selectorWrapper--63b89";
export var separator = "LoginForm-module--separator--6e695";